import TimeSlot from './TimeSlot';

export default TimeSlot;



// WEBPACK FOOTER //
// ./src/components/atoms/TimeSlot/index.js